import { POST_METHOD } from './ApiMethods';

export const postStatusMsg = async (msgDetails) => {
    try {
        const response = await POST_METHOD('update/status', msgDetails);
        return response;
    } catch (error) {
        return error;
    }
};
